import * as React from "react";
import {PropsWithChildren, useCallback} from "react";
import {classNames} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";

interface AppContainerProps {
    apps: string[];
    active?: string;
    onRootRef: (appId: string, root: HTMLElement) => void;
}

export function AppContainer({apps, active, onRootRef}: AppContainerProps) {
    return (
        <div className={classNames(styles.appContainer, active && styles.appContainerActive)}>
            {apps.map(appId => (
                <div className={classNames(styles.app, appId == active && styles.appActive)} key={appId}>
                    <AppRoot key={appId} appId={appId} onRootRef={onRootRef}/>
                </div>
            ))}
        </div>
    )
}

export function SettingsContainer({children}: PropsWithChildren<{}>) {
    return (
        <div className={classNames(styles.app, styles.appActive)}>
            {children}
        </div>
    )
}

interface AppRootProps {
    appId: string;
    onRootRef: (appId: string, root: HTMLElement) => void;
}

function AppRoot({appId, onRootRef}: AppRootProps) {
    const handleRef = useCallback((ref: HTMLElement | null) => {
        if (ref) {
            onRootRef(appId, ref);
        }
    }, [onRootRef, appId]);
    return <div className={styles.appRoot} ref={handleRef}/>;
}

const styles = stylesheet({
    appContainer: {
        overflow: "hidden",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        visibility: "hidden",
    },
    appContainerActive: {
        visibility: "visible",
    },
    app: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        height: "100%",
        visibility: "hidden",
        transform: "scale(0.5)",
        transformOrigin: "center center",
        transition: "transform 0.2s 0s, visibility 0.2s 0.2s, opacity 0.2s 0s, width 0s 0.2s",
        background: "#fff",
        opacity: 0,
    },
    appActive: {
        width: "100%",
        visibility: "visible",
        opacity: 1,
        transform: "scale(1)",
        transition: "transform 0.2s 0s, visibility 0.2s 0s, opacity 0.2s 0s, width 0s 0s",
    },
    appRoot: {
        width: "100%",
        height: "100%",
        $nest: {
            "> *": {
                height: "100%",
            }
        }
    }
})
